import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
import LayoutOperation from "../../components/layout_operation";
import Cookies from "js-cookie";
import ServiceApi from "../../services/ServiceApi";
import { Input, Select } from "antd";
import FaultMonthlyReport from "./fault_monthly_report";
import JobDailyReport from "./job_daily_report";
import "./report.css";
import NoReportSvg from "./no-report.svg";
import iReportList from "./icon-report-list.png";
import RepairPointReport from "./RepairPointReport";
import TRSReport from "./trs_report";
import BTSReport from "./bts_report";

const apiData = {
  langUpdate: false,
  langData: [[]],
  areaCode: [],
  areaCodeTRS: [],
  vendorListTRS:[],
  vendor: [],
  jobType: [],
  jobListAll: "",
  payType: [
    { payId: "NULL", payName: "ไม่ระบุ" },
    { payId: "1", payName: "จ้างเหมา" },
    { payId: "2", payName: "จ้างรายครั้ง" },
  ],
  jobStatus: [],
};

const { Search } = Input;
const { Option } = Select;
const url = window.location.href;

const reportFunction = [
  {
    id: 0,
    name: "Job",
    reportTRS: [
      {
        id: "Form_For_MA_Fiber_Subcontractor",
        name: "Form For MA Fiber Subcontractor",
      },
      { id: "Fault_Monthly_Material_Report", name: "Balance Material Report" },
      { id: "Job_Daily_Report", name: "Job Daily Report" },
      {
        id: "Maintenance_Location_Report",
        name: "Maintenance Location Report",
      },
    ],
    reportBTS: [
      { id: "Fault_Monthly_Report", name: "Fault Monthly Report" },
      { id: "Fault_Monthly_Material_Report", name: "Balance Material Report" },
      { id: "Job_Daily_Report", name: "Job Daily Report" },
      {
        id: "Maintenance_Location_Report",
        name: "Maintenance Location Report",
      },
    ],
  },
  { id: 1, name: "Payment", report: [] },
  { id: 2, name: "Others", report: [] },
];

// const { REACT_APP_BASE_URL } = process.env;
// const domainReport = REACT_APP_BASE_URL+"/report";

class Report extends Component {
  constructor(props) {
    super(props);

    this.state = {
      functionId: 0,
      reportId: "",
      areaId: null,
      countReport: 0,
      displayTRSReportList: "none",
      displayBTSReportList: "none"
    };

  }

  setFunction = (value) => {
    this.setState({ functionId: value });
  };

  setReport = (value) => {
    this.setState({ reportId: value });
  };

  componentDidMount() {
    const companyId = Cookies.get("companyid");
    const operatorId = Cookies.get("operator_id");
    const projectId = Cookies.get("project_id");
    const username = Cookies.get("username");

    ServiceApi.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((res) => {
        apiData.langData = JSON.parse(
          res.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
        );
        apiData.langUpdate = true;
      })
      .catch((e) => {
        console.log("error loading language", e);
      });

    ServiceApi.post("master_data/work_area_center", {
      company_id: companyId,
      operator_id: operatorId,
      project_id: projectId,
      is_activ: 1,
      where: "",
    })
      .then((res) => {
        apiData.areaCode = res.data.data.result;
      })
      .catch((e) => {
        console.log("error loading area code", e);
      });

    ServiceApi.post("V4/get_job_type", {
      company_id: companyId,
      operator_id: operatorId,
      project_id: projectId,
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: 1,
      sql_where: null,
      UserName: username,
    })
      .then((res) => {
        apiData.jobType = res.data.data;
      })
      .catch((e) => {
        console.log("error loading job type", e);
      });

    ServiceApi.post("master_data/GetWFProcessList", {
      WF_ID: 58,
      EnableGroupStatus: true,
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          apiData.jobStatus = data;
        }
      })
      .catch((e) => {
        console.log("error loading job status", e);
      });

      if(url.includes("?trs")== true){
        this.setState({displayTRSReportList: "block", displayBTSReportList: "none"});
      } else if(url.includes("?bts")== true){
        this.setState({displayTRSReportList: "none", displayBTSReportList: "block"});
      } else {
        this.setState({displayTRSReportList: "none", displayBTSReportList: "none"});
      }
  }

  setAreaTRS = (value) => {
    this.setState({ areaId: value });

    ServiceApi.post("master_data/GetTeamGroupAreaReport", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      team_group_duty_code: "O",
      area_code: value,
    })
      .then((res) => {
        this.setState({ vendorList: res.data.list });
      })
      .catch((e) => {
        console.log("error loading vendor", e);
      });

  };

  setLink = (page) => {
    console.log('page='+page);
    let path = url.replace("?trs","");
    path = path.replace("?bts","");
    if(page === "trs"){
      Cookies.set("companyid", 3);
      Cookies.set("operator_id", 4);
      Cookies.set("project_id", 6);
      window.location.href = ServiceApi.absoluteUrl("/report?trs")
    } else if(page === "bts"){
      Cookies.set("companyid", 3);
      Cookies.set("operator_id", 4);
      Cookies.set("project_id", 7);
      window.location.href = ServiceApi.absoluteUrl("/report?bts")
    } else {
      window.location.href = path;
    }
  }

  render() {
    const title = "Report";
    return (
      <LayoutOperation active={7}>
        <div className="wrapper-header">
          <div className="container-fluid">
            <div className="d-flex job-header">
              <div className="d-flex align-content-center flex-wrap mr-auto">
                <img
                  src={ServiceApi.absoluteUrl("/icon/bbtec/header/Report.svg")}
                  alt={title}
                  title={title}
                />
                <h2 className="text-white">{title}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body my-3">
          <div className="container-fluid">
            <div className="row no-gutters">
              <div className="col-12 col-sm-auto" style={{ width: 287 }}>
                <div className="report-item">
                  <div className="report-header">
                    <img
                      src={ServiceApi.absoluteUrl("/icon/icon_function.svg")}
                      alt="Function"
                      title="Function"
                    />
                    FUNCTION
                  </div>
                  <Search
                    placeholder="Search"
                    allowClear
                    style={{ marginTop: 10 }}
                    onFocus={()=>this.setLink("")}
                  />
                  <div className="report-function-wrapper">
                    {reportFunction.map((item, index) => (
                      <div
                        className={
                          item.id === this.state.functionId
                            ? "report-function-item active"
                            : "report-function-item"
                        }
                        onClick={() => {
                          if (this.state.functionId !== index) {
                            this.setState({ functionId: index, reportId: ""});
                          }
                          this.setLink("");
                        }}
                        key={index}
                      >
                        <div className="report-function-name">{item.name}</div>
                        <div className="report-function-total">
                          {(item.id == 0)?
                           (Cookies.get("project_id") == 6)?
                            reportFunction[0].reportTRS.length+ " reports"
                            :
                            reportFunction[0].reportBTS.length+ " reports"
                          : reportFunction[item.id].report.length+ " reports"}
                        </div>
                      </div>

                    ))}

                    <div className="report-header mt-2">
                      <img src={iReportList} />
                      REPORT LIST
                    </div>

                    <div style={{marginLeft:"20px"}}>
                      <ul id="report-list">
                        <li className="mt-2"><span onClick={()=>this.setLink("trs")} style={{cursor:"pointer"}}>(TRS) Form For MA Fiber Subcontractor</span></li>
                        <li className="mt-2"><span onClick={()=>this.setLink("bts")} style={{cursor:"pointer"}}>(BTS) Fault Monthly Report</span></li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-12 col-sm">
                <div className="report-col-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="report-item">
                        {/** TRS */}
                        {(this.state.displayTRSReportList == "block")?
                        <TRSReport
                              {...apiData}
                            />
                        : null}
                        {/** TRS */}
                        {/** BTS */}
                        {(this.state.displayBTSReportList == "block")?
                        <BTSReport
                              {...apiData}
                            />
                        : ""}
                        {/** BTS */}

                        <div className="report-header">
                          <img
                            src={ServiceApi.absoluteUrl(
                              "/icon/icon_select_report.svg"
                            )}
                            alt="Select report"
                            title="Select report"
                          />
                          SELECT REPORT
                        </div>
                        <div className="report-selector-wrapper">
                          <div className="col-12 col-sm-6 col-sm-push-3">
                            {
                            (reportFunction[this.state.functionId] !== undefined)?
                            (
                                (this.state.functionId == 0)?
                                (<Select
                                  placeholder="Please select report"
                                  className="w-100"
                                  onSelect={this.setReport}
                                >
                                  {(Cookies.get("project_id") == 6)?
                                    (reportFunction[
                                      this.state.functionId
                                    ].reportTRS.map((item, index) => (
                                      <Option value={item.id} key={index}>
                                        <span className="default-thai-font">
                                          {item.name}
                                        </span>
                                      </Option>
                                    ))):
                                    (reportFunction[
                                      this.state.functionId
                                    ].reportBTS.map((item, index) => (
                                      <Option value={item.id} key={index}>
                                        <span className="default-thai-font">
                                          {item.name}
                                        </span>
                                      </Option>
                                    )))
                                  }
                                </Select>)
                                :
                                (reportFunction[this.state.functionId].report.length > 0 )?
                                    (<Select
                                      placeholder="Please select report"
                                      className="w-100"
                                      onSelect={this.setReport}
                                      >
                                      {
                                        reportFunction[
                                        this.state.functionId
                                      ].report.map((item, index) => (
                                        <Option value={item.id} key={index}>
                                          <span className="default-thai-font">
                                            {item.name}
                                            </span>
                                          </Option>))
                                    }
                                    </Select>):
                                    (
                                    <Select
                                     placeholder="Please select report"
                                     className="w-100"
                                     value=""
                                     ></Select>
                                  )
                             ) : (
                              <Select
                                placeholder="Please select report"
                                className="w-100"
                                value=""
                              ></Select>
                             )
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="report-item">
                        <div className="report-header">
                          <img
                            src={ServiceApi.absoluteUrl(
                              "/icon/icon_parameter.svg"
                            )}
                            alt="Parameter"
                            title="Parameter"
                          />
                          PARAMETER
                        </div>
                        <div className="report-parameter-wrapper">
                          {this.state.reportId === "" ? (
                            <div className="no-report-wrapper">
                              <img src={NoReportSvg} alt="No Report" />
                            </div>
                          ) : null}
                          {this.state.functionId === 0 &&
                          this.state.reportId ===
                            "Form_For_MA_Fiber_Subcontractor" ? (
                            <FaultMonthlyReport
                              reportType="Form_For_MA_Fiber_Subcontractor"
                              {...apiData}
                            />
                          ) : null}
                          {this.state.functionId === 0 &&
                          this.state.reportId === "Fault_Monthly_Report" ? (
                            <FaultMonthlyReport
                              reportType="Fault_Monthly_Report"
                              {...apiData}
                            />
                          ) : null}
                          {this.state.functionId === 0 &&
                          this.state.reportId ===
                            "Fault_Monthly_Material_Report" ? (
                            <FaultMonthlyReport
                              reportType="Fault_Monthly_Material_Report"
                              {...apiData}
                            />
                          ) : null}
                          {this.state.functionId === 0 &&
                          this.state.reportId === "Job_Daily_Report" ? (
                            <JobDailyReport {...apiData} />
                          ) : null}
                          {this.state.functionId === 0 &&
                          this.state.reportId ===
                            "Maintenance_Location_Report" ? (
                            <RepairPointReport areaCode={apiData.areaCode} />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});

const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Report);
